import "../i18n";
import "../sentryInstrumentReact";
import React from 'react';

import CheckoutAddressFormContainer from './CheckoutAddressFormContainer';
import CheckoutSummary from './CheckoutSummary';
import CheckoutDonation from './CheckoutDonation';
import CheckoutPayment from './CheckoutPayment';
import { useCart } from './CartContext';
import ProcessingSpinner from '../components/ProcessingSpinner';
import NoItems from './NoItems';
import StoreHeader from './StoreHeader';


function Checkout() {
  const { checkoutSubmitting, rendering, cart } = useCart();

  if (rendering) {
    return (
      <>
        <ProcessingSpinner style={{margin: "5rem auto 4rem",}} />
      </>
    );
  }

  // prevents faulty attempt to submit the form prematurely
  function handleKeyDown(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      return false;
    }
  }

  if (cart.items.length < 1) {
    return (
      <>
        <StoreHeader 
          h1Text={window.gettext("Checkout")}
          headerType="checkout"
          totalItems={0}
        />
        <NoItems />
      </>
    );
  }

  return (
    <>
      {checkoutSubmitting && 
        <dialog open className="dialog-overlay">
          <ProcessingSpinner />
        </dialog>
      }
      <StoreHeader 
        h1Text={window.gettext("Checkout")}
        headerType="checkout"
        totalItems={cart.items.length}
      />
      <form className="form-checkout dynamic-labels" id="#" method="post" onKeyDown={handleKeyDown}>
        <CheckoutAddressFormContainer />
        <div className="form-footer">
          {rendering ? 
            ( 
              <div style={{height: "90%", backgroundColor: "white", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(11,11,11,0.1)", borderRadius: "5px",}}>
              <ProcessingSpinner />
              </div>
            ) : (
              <>
                <CheckoutDonation />
                <fieldset>
                  <CheckoutSummary />
                </fieldset>
                <CheckoutPayment />
              </>
            )} 
        </div>
      </form>
    </>
  );
}

export default Checkout;

